import { send_file } from "../../../../texts/fill";
import { useSendFile } from "../../../../hook/use_send_file";

const SendButton = () => {
  const { sendFile } = useSendFile();

  return (
    <button
      type="button"
      className="btn btn-primary btn-lg"
      onClick={sendFile}
      style={{ marginBottom: '0' }}
    >
      <img src="next.png" style={{ width: '25px', paddingLeft: '5px' }} />
      {send_file}
    </button>
  );
};

export default SendButton;
